(function () {
  'use strict';

  function esc(s) { return String(s).replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }
  function fmt(c) { return '\u00a3' + (c / 100).toFixed(2); }

  /* Fires once per cart mutation with the cart Shopify just returned, so other scripts
     (summer-gifts.js) can react instantly without an extra /cart.js round trip. */
  function notifyCartChanged(cart) {
    window.dispatchEvent(new CustomEvent('ayur:cart:changed', { detail: { cart: cart } }));
  }

  /* \u2500 Copy-to-clipboard for discount code boxes (cart drawer + cart page) */
  window.ayurCopyCoupon = function (code, btn) {
    function done(ok) {
      if (!btn) return;
      var orig = btn.getAttribute('data-orig-label') || btn.textContent;
      btn.setAttribute('data-orig-label', orig);
      btn.textContent = ok ? 'Copied!' : 'Copy failed';
      setTimeout(function () { btn.textContent = orig; }, 1800);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(function () { done(true); }).catch(function () { done(false); });
    } else {
      try {
        var ta = document.createElement('textarea');
        ta.value = code; ta.style.position = 'fixed'; ta.style.opacity = '0';
        document.body.appendChild(ta); ta.select();
        document.execCommand('copy'); document.body.removeChild(ta);
        done(true);
      } catch (e) { done(false); }
    }
  };

  /* \u2500 Instant visual feedback on the "Apply & Checkout" link \u2014 it's a real page
     navigation (Shopify applies the discount server-side, then redirects to
     checkout), so there's no AJAX call to hook into. Without this the button does
     nothing visible for the 1-3 sec the navigation takes. */
  window.ayurApplyingCoupon = function (el) {
    el.textContent = 'Applying\u2026';
    el.style.opacity = '0.65';
    el.style.pointerEvents = 'none';
  };

  /* FIX 1 \u2500 Reset "Apply & Checkout" when user returns via bfcache (browser back).
     DOM is restored exactly as it was on click, so without this the button stays
     stuck at "Applying\u2026" with pointer-events:none indefinitely. */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      document.querySelectorAll('.ayur-coupon-box__apply').forEach(function (btn) {
        btn.textContent = 'Apply & Checkout \u2192';
        btn.style.opacity = '';
        btn.style.pointerEvents = '';
      });
    }
  });

  /* \u2500 Mobile Menu */
  var mT = document.getElementById('mobile-menu-toggle');
  var mM = document.getElementById('mobile-menu');
  var oI = document.getElementById('menu-open-icon');
  var cI = document.getElementById('menu-close-icon');
  if (mT && mM) {
    mT.addEventListener('click', function () {
      var open = mM.classList.toggle('is-open');
      mT.setAttribute('aria-expanded', open);
      if (oI) oI.classList.toggle('is-hidden', open);
      if (cI) cI.classList.toggle('is-hidden', !open);
    });
    mM.querySelectorAll('a').forEach(function (l) {
      l.addEventListener('click', function () {
        mM.classList.remove('is-open');
        if (oI) oI.classList.remove('is-hidden');
        if (cI) cI.classList.add('is-hidden');
        mT.setAttribute('aria-expanded', 'false');
      });
    });
  }

  /* \u2500 Cart Drawer */
  window.openCart = function () {
    document.getElementById('cart-drawer').classList.add('is-open');
    document.getElementById('cart-overlay').classList.add('is-open');
    document.body.style.overflow = 'hidden';
  };
  window.closeCart = function () {
    document.getElementById('cart-drawer').classList.remove('is-open');
    document.getElementById('cart-overlay').classList.remove('is-open');
    document.body.style.overflow = '';
  };

  /* \u2500 Render cart drawer */
  function renderCartDrawer(cart) {
    var countEl = document.getElementById('cart-count');
    if (countEl) { countEl.textContent = cart.item_count; countEl.classList.toggle('is-hidden', cart.item_count === 0); }
    var shipWrap = document.getElementById('cart-shipping-banner');
    if (shipWrap) {
      if (cart.item_count === 0) {
        shipWrap.innerHTML = '';
      } else {
        shipWrap.innerHTML = '<div class="cart-shipping-banner cart-shipping-banner--free">&#10003; You qualify for <strong>free UK shipping</strong>!</div>';
      }
    }
    var wrap   = document.getElementById('cart-drawer__items');
    var footer = document.getElementById('cart-drawer-footer');
    var subEl  = document.getElementById('cart-drawer-subtotal');
    if (!wrap) return cart;
    if (cart.item_count === 0) {
      wrap.innerHTML = '<div class="cart-empty"><div class="cart-empty__icon">&#x1F6CD;</div><p class="cart-empty__text">Your cart is empty</p><a href="/collections/all" class="ayur-btn-primary" onclick="closeCart()">Shop Collection</a></div>';
      if (footer) footer.style.display = 'none';
      return cart;
    }
    var html = '';
    cart.items.forEach(function (item) {
      var isGift = (item.properties && item.properties._summer_gift === '1');
      var qtyHtml = isGift
        ? '<span class="qty-num" style="color:#92400E;font-weight:700;">Qty ' + item.quantity + '</span>'
        : '<button class="qty-btn" onclick="updateCartItem(\'' + item.key + '\', ' + (item.quantity - 1) + ')" aria-label="Decrease">&#x2212;</button>'
          + '<span class="qty-num">' + item.quantity + '</span>'
          + '<button class="qty-btn" onclick="updateCartItem(\'' + item.key + '\', ' + (item.quantity + 1) + ')" aria-label="Increase">&#x2B;</button>';
      html += '<div class="cart-item" data-key="' + esc(item.key) + '">'
        + (item.image ? '<a href="' + item.url + '" class="cart-item__image-link"><img src="' + item.image + '" alt="' + esc(item.title) + '" class="cart-item__image" width="72" height="72" loading="lazy"></a>' : '')
        + '<div class="cart-item__details"><a href="' + item.url + '" class="cart-item__name">' + esc(item.product_title) + (isGift ? ' <span style="color:#92400E;font-size:10.5px;font-weight:700;">(FREE GIFT)</span>' : '') + '</a>'
        + ((item.variant_title && item.variant_title !== 'Default Title') ? '<p class="cart-item__variant">' + esc(item.variant_title) + '</p>' : '')
        + '<div class="cart-item__price-row"><div class="cart-item__qty">'
        + qtyHtml
        + '</div><span class="cart-item__price">' + fmt(item.final_line_price) + '</span></div></div>'
        + '<button class="cart-item__remove" onclick="updateCartItem(\'' + item.key + '\', 0)" title="Remove">&#x2715;</button></div>';
    });
    wrap.innerHTML = html;
    if (footer) { footer.style.display = ''; }
    if (subEl)  { subEl.textContent = fmt(cart.total_price); }
    return cart;
  }

  /* \u2500 Sync card states */
  function syncCardStates(cart) {
    document.querySelectorAll('.ayur-card-qty').forEach(function (s) { s.style.display = 'none'; });
    document.querySelectorAll('.ayur-quick-add-btn[data-variant-id]').forEach(function (b) {
      b.style.display = ''; b.disabled = false; b.style.opacity = '1';
    });
    if (!cart || !cart.items || cart.items.length === 0) return;
    cart.items.forEach(function (item) {
      var vid = String(item.variant_id);
      document.querySelectorAll('.ayur-card-qty[data-variant-id="' + vid + '"]').forEach(function (stepper) {
        stepper.dataset.lineKey = item.key;
        var cEl = stepper.querySelector('.ayur-card-qty__count');
        if (cEl) cEl.textContent = item.quantity;
        stepper.style.display = 'flex';
        var ftr = stepper.closest('.ayur-product-card__footer');
        var addBtn = ftr ? ftr.querySelector('.ayur-quick-add-btn') : null;
        if (addBtn) addBtn.style.display = 'none';
      });
    });
  }

  /* \u2500 Update cart item */
  window.updateCartItem = function (key, quantity) {
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: quantity }) })
    .then(function (r) { return r.json(); })
    .then(function (cart) { renderCartDrawer(cart); syncCardStates(cart); notifyCartChanged(cart); })
    .catch(function (e) { console.error('Cart update failed', e); });
  };

  /* \u2500 Click handler: Quick Add + Stepper */
  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('.ayur-quick-add-btn[data-variant-id]');
    if (addBtn && !addBtn.disabled) {
      var variantId = addBtn.getAttribute('data-variant-id');
      addBtn.disabled = true; addBtn.textContent = 'Adding\u2026'; addBtn.style.opacity = '0.75';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: 'id=' + encodeURIComponent(variantId) + '&quantity=1' })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'Error'); });
        return fetch('/cart.js');
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCartDrawer(cart); syncCardStates(cart); openCart(); notifyCartChanged(cart); addBtn.textContent = 'Quick Add'; addBtn.style.opacity = '1'; addBtn.disabled = false; })
      .catch(function (err) { console.error('Quick add failed:', err.message || err); addBtn.textContent = 'Quick Add'; addBtn.style.opacity = '1'; addBtn.disabled = false; });
      return;
    }
    var incBtn = e.target.closest('.ayur-card-qty__inc');
    if (incBtn) {
      var stepper = incBtn.closest('.ayur-card-qty');
      var cEl = stepper.querySelector('.ayur-card-qty__count');
      var newQty = (parseInt(cEl.textContent, 10) || 0) + 1;
      cEl.textContent = newQty;
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: stepper.dataset.lineKey, quantity: newQty }) })
      .then(function (r) { return r.json(); }).then(function (cart) { renderCartDrawer(cart); syncCardStates(cart); notifyCartChanged(cart); })
      .catch(function (e) { console.error('Stepper + failed', e); });
      return;
    }
    var decBtn = e.target.closest('.ayur-card-qty__dec');
    if (decBtn) {
      var stepper = decBtn.closest('.ayur-card-qty');
      var cEl = stepper.querySelector('.ayur-card-qty__count');
      var newQty = Math.max(0, (parseInt(cEl.textContent, 10) || 0) - 1);
      if (newQty === 0) {
        stepper.style.display = 'none';
        var ftr = stepper.closest('.ayur-product-card__footer');
        var btn = ftr ? ftr.querySelector('.ayur-quick-add-btn') : null;
        if (btn) btn.style.display = '';
      } else { cEl.textContent = newQty; }
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: stepper.dataset.lineKey, quantity: newQty }) })
      .then(function (r) { return r.json(); }).then(function (cart) { renderCartDrawer(cart); syncCardStates(cart); notifyCartChanged(cart); })
      .catch(function (e) { console.error('Stepper - failed', e); });
      return;
    }
  });

  /* \u2500 Product page Add to Cart (AJAX) */
  var atcForm = document.getElementById('ayur-atc-form');
  if (atcForm) {
    atcForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = document.getElementById('atc-btn');
      var stickyBtn = document.getElementById('sticky-atc-btn');
      [btn, stickyBtn].forEach(function (b) {
        if (!b) return;
        b.dataset.origLabel = b.textContent;
        b.disabled = true; b.textContent = 'Adding\u2026'; b.style.opacity = '0.75';
      });
      var formData = new FormData(atcForm);
      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'Error'); });
          return fetch('/cart.js');
        })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          renderCartDrawer(cart); syncCardStates(cart); openCart(); notifyCartChanged(cart);
        })
        .catch(function (err) { console.error('Add to cart failed:', err.message || err); })
        .then(function () {
          [btn, stickyBtn].forEach(function (b) {
            if (!b) return;
            b.disabled = false; b.textContent = b.dataset.origLabel || 'Add to Cart'; b.style.opacity = '1';
          });
        });
    });
  }

  /* \u2500 Init card states on load */
  fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) { syncCardStates(cart); }).catch(function () {});

  /* \u2500 FAQ Accordion */
  document.querySelectorAll('.ayur-faq-item__q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.ayur-faq-item');
      var ans  = item.querySelector('.ayur-faq-item__a');
      var open = item.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open);
      if (open) { ans.removeAttribute('hidden'); } else { ans.setAttribute('hidden', ''); }
    });
  });

  /* \u2500 Product Tabs */
  window.switchTab = function (id, btn) {
    document.querySelectorAll('.ayur-tab-btn').forEach(function (b) { b.classList.remove('is-active'); });
    document.querySelectorAll('.ayur-tab-panel').forEach(function (p) { p.classList.remove('is-active'); });
    if (btn) btn.classList.add('is-active');
    var p = document.getElementById('tab-' + id); if (p) p.classList.add('is-active');
  };

  /* \u2500 Gallery */
  window.setMainImage = function (src, t) {
    var img = document.getElementById('main-product-img');
    if (img) { img.src = src; img.srcset = ''; img.sizes = ''; }
    document.querySelectorAll('.ayur-product-gallery__thumb').forEach(function (x) { x.classList.remove('is-active'); });
    if (t) t.classList.add('is-active');
  };

  /* FIX 2 \u2500 Qty stepper helper: recalculates displayed price when qty changes */
  function ayurUpdatePriceForQty(qty) {
    var idInput = document.getElementById('variant-id-input');
    var dataEl  = document.getElementById('ayur-product-variants');
    if (!idInput || !dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var vid = parseInt(idInput.value, 10);
    var match = null;
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].id === vid) { match = variants[i]; break; }
    }
    if (!match) return;
    var priceEl   = document.getElementById('product-price');
    var compareEl = document.getElementById('product-compare-price');
    var stickyEl  = document.getElementById('sticky-product-price');
    if (priceEl)   priceEl.textContent = fmt(match.price * qty);
    if (stickyEl)  stickyEl.textContent = fmt(match.price * qty);
    if (compareEl) {
      if (match.compare_at_price > match.price) {
        compareEl.textContent = fmt(match.compare_at_price * qty);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }
  }

  window.adjustQty = function (d) {
    var inp = document.getElementById('qty-input');
    if (!inp) return;
    var newQty = Math.max(1, (parseInt(inp.value, 10) || 1) + d);
    inp.value = newQty;
    ayurUpdatePriceForQty(newQty);
  };

  /* FIX 3 \u2500 Variant selector: multiply price by current qty */
  window.selectVariant = function (optionIndex, value) {
    var groups = document.querySelectorAll('.ayur-variant-group');
    if (groups[optionIndex]) {
      groups[optionIndex].querySelectorAll('.ayur-variant-pill').forEach(function (p) {
        p.classList.toggle('is-selected', p.getAttribute('data-value') === value);
      });
    }
    var dataEl = document.getElementById('ayur-product-variants');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var selectedOptions = [];
    document.querySelectorAll('.ayur-variant-group').forEach(function (group) {
      var active = group.querySelector('.ayur-variant-pill.is-selected');
      selectedOptions.push(active ? active.getAttribute('data-value') : null);
    });
    var match = null;
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].options.every(function (opt, idx) { return selectedOptions[idx] === opt; })) {
        match = variants[i]; break;
      }
    }
    if (!match) return;
    var priceEl   = document.getElementById('product-price');
    var compareEl = document.getElementById('product-compare-price');
    var qtyInp    = document.getElementById('qty-input');
    var currentQty = qtyInp ? Math.max(1, parseInt(qtyInp.value, 10) || 1) : 1;
    if (priceEl) priceEl.textContent = fmt(match.price * currentQty);
    if (compareEl) {
      if (match.compare_at_price > match.price) { compareEl.textContent = fmt(match.compare_at_price * currentQty); compareEl.style.display = ''; }
      else { compareEl.style.display = 'none'; }
    }
    var idInput = document.getElementById('variant-id-input');
    if (idInput) idInput.value = match.id;
    var atcBtn = document.getElementById('atc-btn');
    if (atcBtn) { atcBtn.disabled = !match.available; atcBtn.textContent = match.available ? 'Add to Cart' : 'Sold Out'; }
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({ variant: match.id }, '', url.toString());
    } catch (e) {}
    if (typeof window.updatePackPricing === 'function') window.updatePackPricing();
    var stickyPriceEl = document.getElementById('sticky-product-price');
    if (stickyPriceEl) stickyPriceEl.textContent = fmt(match.price * currentQty);
    var stickyBtn = document.getElementById('sticky-atc-btn');
    if (stickyBtn) { stickyBtn.disabled = !match.available; stickyBtn.textContent = match.available ? 'Add to Cart' : 'Sold Out'; }
  };

  /* \u2500 Sticky header */
  var h = document.getElementById('site-header');
  if (h) window.addEventListener('scroll', function () { h.style.boxShadow = window.scrollY > 8 ? '0 2px 16px rgba(0,0,0,0.07)' : ''; }, { passive: true });



  /* \u2500 Bundle pack count per "Packs" option label */
  var AYUR_PACK_BOTTLE_COUNT = { 'Buy 1': 1, 'Buy 2': 2, 'Buy 3': 3, 'Buy 4 get 1 Free': 5 };

  window.updatePackPricing = function () {
    var dataEl = document.getElementById('ayur-product-variants');
    var packGroup = document.querySelector('.ayur-variant-group[data-option-name="Packs"]');
    if (!dataEl || !packGroup) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var sizeGroup = document.querySelector('.ayur-variant-group[data-option-name="Size"]');
    var sizeActive = sizeGroup ? sizeGroup.querySelector('.ayur-variant-pill.is-selected') : null;
    var sizeVal = sizeActive ? sizeActive.getAttribute('data-value') : null;

    function findVariant(packLabel) {
      for (var i = 0; i < variants.length; i++) {
        var opts = variants[i].options;
        if (opts.indexOf(packLabel) === -1) continue;
        if (sizeVal && opts.indexOf(sizeVal) === -1) continue;
        return variants[i];
      }
      return null;
    }

    var baseVariant = findVariant('Buy 1');
    var baseUnit = baseVariant ? baseVariant.price : null;

    var bestPct = 0, bestBtn = null;
    packGroup.querySelectorAll('.ayur-pack-pill').forEach(function (btn) {
      btn.classList.remove('ayur-pack-pill--best');
      var oldTag = btn.querySelector('.ayur-pack-best-tag');
      if (oldTag) oldTag.remove();
      var oldStock = btn.querySelector('.ayur-pack-stock-low');
      if (oldStock) oldStock.remove();

      var label = btn.getAttribute('data-value');
      var match = findVariant(label);
      var sub = btn.querySelector('[data-pack-savings]');
      if (!match || !sub) { if (sub) sub.textContent = ''; return; }

      var qty = AYUR_PACK_BOTTLE_COUNT[label] || 1;
      var perBottle = match.price / qty;
      var pct = (baseUnit && qty > 1) ? Math.round((1 - (match.price / (baseUnit * qty))) * 100) : 0;

      sub.textContent = fmt(perBottle) + ' / bottle' + (pct > 0 ? ' \u00b7 Save ' + pct + '%' : '');

      if (pct > bestPct) { bestPct = pct; bestBtn = btn; }

      if (match.inventory_management === 'shopify' && match.inventory_quantity > 0 && match.inventory_quantity < 30) {
        var stockEl = document.createElement('span');
        stockEl.className = 'ayur-pack-stock-low';
        stockEl.textContent = 'Only ' + match.inventory_quantity + ' left';
        btn.appendChild(stockEl);
      }
    });

    if (bestBtn && bestPct > 0) {
      bestBtn.classList.add('ayur-pack-pill--best');
      var tag = document.createElement('span');
      tag.className = 'ayur-pack-best-tag';
      tag.textContent = 'BEST VALUE';
      bestBtn.appendChild(tag);
    }
  };

  /* \u2500 Sticky mobile Add to Cart bar */
  (function () {
    var bar = document.getElementById('ayur-sticky-atc');
    var trigger = document.getElementById('ayur-atc-trigger');
    if (!bar || !trigger || !('IntersectionObserver' in window)) return;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('is-visible', !entry.isIntersecting && window.innerWidth <= 600);
      });
    }, { threshold: 0 });
    obs.observe(trigger);
    window.addEventListener('resize', function () {
      if (window.innerWidth > 600) bar.classList.remove('is-visible');
    });
  })();

  document.addEventListener('DOMContentLoaded', function () {
    if (typeof window.updatePackPricing === 'function') window.updatePackPricing();
  });
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    if (typeof window.updatePackPricing === 'function') window.updatePackPricing();
  }

  /* \u2500 Expose internals for summer-gifts.js */
  window.renderCartDrawer = renderCartDrawer;
  window.ayurSyncCardStates = syncCardStates;

})();
